module.exports = __webpack_public_path__ + "img/solution2.0b06217b.png";